window.listeningForCursorMove = false;

function initCursor(){
    var cursorOptions = listTrialCursorOptions[window.trialRow];
    if (cursorOptions === undefined){
        return;
    }
    if(cursorOptions.cursor){
        switch(cursorOptions.cursor){
            case "file":
                //to be added later
                break;
            case "hide":
                changeCursor('none');
                break;
            case "hideStart":
                hideCursorUntilMovement();
                break;
            case "crosshair":
            case "pointer":
                changeCursor(cursorOptions.cursor);
                break;
            default:
                break;
        }

    }
    
}

function changeCursor(replacement){
    $('html').css('cursor', replacement);
}

function resetCursor(){
    if(!window.listeningForCursorMove) {
        $('html').css('cursor', '');
        return;
    }

    const minimumDelay = 50;
    const cursorMoveTimeSinceMove = performance.now() - window.listeningForCursorMoveTimestamp;
    if(cursorMoveTimeSinceMove >= minimumDelay && window.listeningForCursorMove == true){
        $('html').css('cursor', '');
        document.documentElement.removeEventListener('pointermove', resetCursor);
        window.listeningForCursorMove = false;
    }
}


function hideCursorUntilMovement(){
    changeCursor('none');
    window.listeningForCursorMoveTimestamp = performance.now();
    window.listeningForCursorMove = true;
    document.documentElement.addEventListener('pointermove', resetCursor);
}

function getCursorOptions(responseOptionsRaw){
	if(responseOptionsRaw == 'na'){
		return;
    }
    var options = {};
    const optionRegex = /(\w+\.\w+)|(\w+)/g;
	var matches = optionRegex.exec(responseOptionsRaw);
    while(matches !== null){
        if(matches[2]){
            options.cursor = matches[2];
        }
        else if(matches[1]){
            options.cursor = file;
            options.filename = matches[2];
        }
        matches = optionRegex.exec(responseOptionsRaw);
    }
	return options;
}

function getCursorForCurrentTrial() {
    if(!window.listTrialCursorOptions[window.trialRow]){
		return;
    }

    return window.listTrialCursorOptions[window.trialRow].cursor;
}